import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core'
import { OrgBrowserView } from '../../models/org-browser-view'
import { OrganizationDataGateway } from '../../gatewasys/organization-data.gateway'
@Component({
    selector: 'org-search',
    templateUrl: './org-search.component.html',
    styleUrls: ['./org-search.component.scss']
})
export class OrgSearchComponent implements OnInit {
    @Input() rootOrgId: number
    @Output() orgSelected: EventEmitter<OrgBrowserView> = new EventEmitter()
    @Output() orgUnSelected: EventEmitter<OrgBrowserView> = new EventEmitter()
    @Output() searchResultChanged: EventEmitter<OrgBrowserView[]> = new EventEmitter()
    @Output() orgAdded: EventEmitter<OrgBrowserView> = new EventEmitter()
    @Input() resetSearch: string

    keyWord: string = ''
    hasError: boolean = false
    errorMessage: string | undefined = ''
    loading: boolean = false
    organizations: OrgBrowserView[] = [] as OrgBrowserView[]
    constructor(private orgDataGateway: OrganizationDataGateway) {}

    ngOnInit() {
        this.keyWord = ''
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.resetSearch !== undefined) {
            this.keyWord = ''
            this.organizations = [] as OrgBrowserView[]
            this.hasError = false
            this.errorMessage = undefined
        }
    }

    onSearch(): void {
        this.loading = true
        if (this.keyWord === undefined || this.keyWord === null || this.keyWord === '' || this.keyWord.length < 3) {
            this.hasError = false
            //this.showError('to avoid listing all organizations the keyword must be atleast 3 characters long');
            return
        }
        this.orgDataGateway.searchOrganization(this.keyWord).subscribe(
            (orgs) => {
                if (orgs === undefined || orgs === null || orgs.length <= 0) {
                    this.organizations = [] as OrgBrowserView[]
                    this.showError('Cannot find Organizations matching this keyword')
                } else {
                    const activeOrgs: OrgBrowserView[] = orgs
                        .filter((o) => o.isActive === true)
                        .sort((a: OrgBrowserView, b: OrgBrowserView) => {
                            if (a.orgName.toLowerCase() > b.orgName.toLowerCase()) {
                                return 1
                            } else if (a.orgName.toLowerCase() < b.orgName.toLowerCase()) {
                                return -1
                            } else {
                                return 0
                            }
                        })
                    const inActiveOrgs: OrgBrowserView[] = orgs
                        .filter((o) => o.isActive === false)
                        .sort((a: OrgBrowserView, b: OrgBrowserView) => {
                            if (a.orgName.toLowerCase() > b.orgName.toLowerCase()) {
                                return 1
                            } else if (a.orgName.toLowerCase() < b.orgName.toLowerCase()) {
                                return -1
                            } else {
                                return 0
                            }
                        })
                    this.organizations = activeOrgs.concat(inActiveOrgs)
                    this.searchResultChanged.emit(this.organizations)
                    this.closeError()
                }
            },
            (error) => {
                console.log(error)
                this.showError('Something went wrong with the search. please try again')
            }
        )
    }

    showError(message: string): void {
        this.errorMessage = message
        this.hasError = true
    }

    closeError(): void {
        this.hasError = false
        this.errorMessage = undefined
    }

    orgUnSelect(org: OrgBrowserView): void {
        if (this.organizations === undefined || this.organizations === null) {
            return
        }
        const foundOrgs = this.organizations.filter((o) => o.orgId === org.orgId)
        if (foundOrgs !== undefined || foundOrgs !== null) {
            foundOrgs.forEach((o) => (o.selected = false))
        }
    }

    addOrg(org: OrgBrowserView): void {
        org.selected = true
        this.orgAdded.emit(org)
    }
}
